var _rect, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 140,
    viewBox: "0 0 161 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160.55,
    height: 140,
    rx: 70,
    fill: "#F3E3E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.9724 52.7497L67.7684 51.3236C66.888 50.7539 65.7278 50.8851 64.9967 51.637L62.6228 54.0788C61.9273 54.7941 61.8005 55.8879 62.3138 56.7434L63.7613 59.1558C64.1189 59.7519 64.1737 60.482 63.909 61.1248L62.804 63.8085C62.5517 64.421 62.0368 64.8873 61.4023 65.0776L58.4743 65.956C57.5441 66.2351 56.907 67.0913 56.907 68.0626V71.0321C56.907 72.0413 57.5938 72.921 58.5729 73.1657L61.3143 73.8511C61.9994 74.0224 62.5606 74.5122 62.8229 75.1679L63.9308 77.9376C64.1825 78.5669 64.13 79.2771 63.7885 79.8626L62.3521 82.3249C61.8236 83.2309 62.0084 84.384 62.7936 85.0795L65.058 87.085C65.7712 87.7168 66.8101 87.8174 67.6313 87.3343L69.9976 85.9424C70.5842 85.5973 71.2975 85.5433 71.9295 85.796L74.657 86.8871C75.3336 87.1577 75.8321 87.7458 75.9884 88.4575L76.5965 91.2277C76.8179 92.2366 77.7117 92.9555 78.7446 92.9555H81.9838C82.9977 92.9555 83.8802 92.2623 84.1204 91.2773L84.8173 88.42C84.9857 87.7295 85.4774 87.163 86.1372 86.8991L88.7285 85.8626C89.4522 85.5731 90.2752 85.6884 90.8916 86.1656L92.6884 87.5566C93.5369 88.2135 94.7355 88.1622 95.5248 87.4353L97.9985 85.1568C98.7947 84.4235 98.9389 83.2198 98.3385 82.3192L96.9776 80.2779C96.5878 79.6931 96.5009 78.9571 96.7439 78.2976L97.8741 75.23C98.1286 74.539 98.7121 74.0213 99.4284 73.8508L102.365 73.1516C103.356 72.9157 104.055 72.0305 104.055 71.0121V68.0852C104.055 67.1032 103.404 66.2402 102.46 65.9705L99.3056 65.0693C98.6588 64.8845 98.1322 64.4139 97.8761 63.792L96.7888 61.1513C96.518 60.4937 96.5819 59.7457 96.9604 59.1435L98.4216 56.819C98.9796 55.9312 98.8333 54.7731 98.0721 54.0519L95.4697 51.5865C94.7073 50.8642 93.5407 50.7817 92.6843 51.3895L90.8738 52.6743C90.2647 53.1066 89.4777 53.2002 88.7842 52.9228L86.1919 51.8858C85.5018 51.6098 84.9978 51.0039 84.8521 50.2752L84.3396 47.7131C84.134 46.6851 83.2314 45.9451 82.183 45.9451H78.6413C77.5929 45.9451 76.6903 46.6851 76.4847 47.7131L75.9723 50.2752C75.8265 51.0039 75.3225 51.6098 74.6325 51.8858L71.984 52.9452C71.3214 53.2103 70.5715 53.1374 69.9724 52.7497Z",
    stroke: "#DD4F34",
    strokeWidth: 2.74914,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.4118,
    cy: 69.5876,
    r: 9.07217,
    stroke: "#DD4F34",
    strokeWidth: 2.74914
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.3951,
    cy: 34.536,
    r: 3.16152,
    stroke: "#DD4F34",
    strokeWidth: 2.74914
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.189,
    cy: 45.8076,
    r: 3.16152,
    stroke: "#DD4F34",
    strokeWidth: 2.74914
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.014,
    cy: 83.7457,
    r: 3.16152,
    stroke: "#DD4F34",
    strokeWidth: 2.74914
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.117,
    cy: 105.464,
    r: 3.16152,
    stroke: "#DD4F34",
    strokeWidth: 2.74914
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.4293,
    cy: 105.464,
    r: 3.16152,
    stroke: "#DD4F34",
    strokeWidth: 2.74914
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5361,
    cy: 93.9175,
    r: 3.16152,
    stroke: "#DD4F34",
    strokeWidth: 2.74914
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5361,
    cy: 54.6051,
    r: 3.16152,
    stroke: "#DD4F34",
    strokeWidth: 2.74914
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5327,
    cy: 35.6357,
    r: 3.16152,
    stroke: "#DD4F34",
    strokeWidth: 2.74914
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2578 49.2439L95.2578 40.0343",
    stroke: "#DD4F34",
    strokeWidth: 2.74914,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.9 69.3824H112.498C113.712 69.3824 114.697 68.3977 114.697 67.183V51.6504",
    stroke: "#DD4F34",
    strokeWidth: 2.74914,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4122 43.7455V37.5599C80.4122 36.3452 79.4276 35.3606 78.2129 35.3606H61.0308",
    stroke: "#DD4F34",
    strokeWidth: 2.74914,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9313 54.7424H50.0344",
    stroke: "#DD4F34",
    strokeWidth: 2.74914,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7079 69.4503H46.4604C45.2458 69.4503 44.2611 70.4349 44.2611 71.6496V88.2819",
    stroke: "#DD4F34",
    strokeWidth: 2.74914,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4297 90.2062V99.9657",
    stroke: "#DD4F34",
    strokeWidth: 2.74914,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9622 95.4296V103.127C80.9622 104.342 81.9468 105.327 83.1615 105.327H100.619",
    stroke: "#DD4F34",
    strokeWidth: 2.74914,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101.581 84.2956H110.516",
    stroke: "#DD4F34",
    strokeWidth: 2.74914,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomation);
export default __webpack_public_path__ + "static/media/automation.fda22e1812831d86afe8e2cef46fce7a.svg";
export { ForwardRef as ReactComponent };